export default __webpack_public_path__ + "static/services-image2-b192c122c42422576e77df25e6c8470b.jpg";